<template>
      <b-row>
        <b-col sm="12" md="2">
          <b-nav vertical class="nav-right border my-3">
            <b-nav-item @click="activeTab(0)" :active="is_active === 0">
              {{$t('simple.system_setting')}}
            </b-nav-item>
            <b-nav-item @click="activeTab(1)" :active="is_active === 1">
              {{$t('simple.automation')}}
            </b-nav-item>
          </b-nav>

        </b-col>
        <b-col sm="12" md="10">
          <!--  Page  -->
          <div v-if="is_active === 0  && user_permissions.includes('read-configurations')" class=" tab-0 w-100 bg-white rounded py-2 shadow-widget border">

            <!-- Page header -->
            <div class="px-3">

              <div class="d-flex">

                <h4>{{ $t('page.configurations') }}</h4>

                <div class="ml-auto align-self-center">


                </div>

              </div>

              <span class="text-muted font-weight-light">{{ $t('page.configurations_desc') }}</span>

            </div>

            <hr>
            <v-wait class="w-100" for="accounts">
              <loading slot="waiting" />

              <v-wait class="v-100" for="configurations">
                <loading slot="waiting" />
                <!-- Page content -->
                <div class="px-3">
                  <span><strong>{{ $t('player.player') }}</strong></span>
                  <span class="text-muted font-weight-light"> - {{ $t('configuration.player_desc') }}</span>
                  <hr>

                  <b-container fluid>
                    <b-row>
                      <b-col class="pr-1 col-sm-12 col-md-2" v-b-tooltip.hover
                             :title="$t('configuration.player_mode_desc')">{{ $t('configuration.player_mode')
                        }}</b-col>
                      <b-col class="col-sm-12 col-md-4">
                        <div>
                          <b-form-group>
                            <b-form-radio v-b-tooltip.hover
                                          :title="$t('configuration.gamification_desc')" v-model="player_mode"
                                          name="some-radios" value="1"><span>{{ $t('configuration.inboxzero')
                              }}</span></b-form-radio>
                            <b-form-radio v-b-tooltip.hover.bottom
                                          :title="$t('configuration.inboxzero_desc')" v-model="player_mode"
                                          name="some-radios" value="2"><span>{{
                                $t('configuration.gamification')
                              }}</span></b-form-radio>
                          </b-form-group>
                        </div>
                      </b-col>
                    </b-row>
                    <hr>
                    <b-row class="pb-3">
                      <b-col class="col-sm-12 col-md-2 pb-2" v-b-tooltip.hover
                             :title="$t('configuration.gamification_counter_desc')">{{
                          $t('configuration.gamification_counter') }}</b-col>
                      <b-col>
                        <div>
                          <b-form-spinbutton id="gmf-counter" v-model="gamification_counter" min="1"
                                             max="10" inline></b-form-spinbutton>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="col-sm-12 col-md-2 col-xl-2 pb-2" v-b-tooltip.hover
                             :title="$t('configuration.gamification_last_reply_counter_desc')">{{
                          $t('configuration.gamification_last_reply_counter') }}</b-col>
                      <b-col>
                        <div>
                          <b-form-spinbutton id="last-reply-count"
                                             v-model="gamification_last_reply_counter" min="1" max="10"
                                             inline></b-form-spinbutton>
                        </div>
                      </b-col>
                    </b-row>
                  </b-container>

                  <hr>
                  <span><strong>{{ $t('configuration.warnings') }}</strong></span>
                  <span class="text-muted font-weight-light"> - {{ $t('configuration.warnings_desc') }}</span>
                  <hr>

                  <b-container fluid>
                    <b-row>
                      <b-col class="col-sm-12 col-md-2 pb-2" v-b-tooltip.hover
                             :title="$t('configuration.message_frequency_desc')">{{
                          $t('configuration.message_frequency') }}</b-col>
                      <b-col>
                        <div>
                          <b-form-spinbutton id="warn-count" v-model="warn_message_count" min="25"
                                             inline></b-form-spinbutton>
                        </div>
                      </b-col>
                    </b-row>

                    <hr>

                    <b-row>
                      <div class="col-sm-12 col-md-2 pb-2" v-b-tooltip.hover
                           :title="$t('configuration.popular_account_desc')">
                        {{ $t('configuration.popular_account') }}
                      </div>
                      <b-col>
                        <div>
                          <b-form-spinbutton id="warn-popular" v-model="warn_popular_account_count"
                                             min="10000" max="Infinity" step="1000" inline></b-form-spinbutton>
                        </div>
                      </b-col>
                    </b-row>
                  </b-container>
                  <hr>
                  <span class="mt-3"><strong>{{
                      $t('configuration.translation_configuration') }}</strong></span>
                  <span class="text-muted font-weight-light"> - {{
                      $t('configuration.translation_desc') }}</span>
                  <hr>
                  <b-container fluid>
                    <ConfigurationCheckbox :label="$t('configuration.translation_status')"
                                           :value="translationActive" @handleChange="setTranslationActive($event)" />

                    <template v-if="translationActive === 'true' || translationActive === true">
                      <br>
                      <PasswordInput :label="$t('configuration.translation_api_key')"
                                     :value="translationApiKey"
                                     @handlePasswordChange="setTranslationApiKey($event)" />
                    </template>
                  </b-container>
                  <hr>
                  <!-- TODO: may change it according to new notification center settings -->
                  <span class="mt-3"><strong>{{ $t('configuration.notification_configuration')
                    }}</strong></span>
                  <span class="text-muted font-weight-light"> - {{ $t('configuration.notification_desc')
                    }}</span>
                  <hr>

                  <b-container fluid>
                    <ConfigurationCheckbox :label="$t('configuration.notification_status')"
                                           :value="notificationActive" @handleChange="setNotificationActive($event)" />

                    <template v-if="notificationActive === 'true' || notificationActive === true">
                      <br>
                      <SendForSelection title="Send Notification For"
                                        :label="$t('configuration.send_for')" :value="notificationSendFor"
                                        :radioButtonOptions="sendForOptions"
                                        @handleRadioButtonChange="handleNotificationSendFor($event)"
                                        :integration_value="notificationSelectedIntegrations"
                                        @handleIntegrationChange="setNotificationSelectedIntegrations($event)"
                                        :account_value="notificationSelectedAccounts"
                                        @handleAccountChange="setNotificationSelectedAccounts($event)" />
                      <br>


                      <TimeSelection :time_from="notification_time_from"
                                     @handleTimeFrom="handleNotificationTimeFrom($event)"
                                     :time_to="notification_time_to"
                                     @handleTimeTo="handleNotificationTimeTo($event)" />
                      <br>

                      <ConfigurationCheckboxGroup
                          :value="notificationMessageType"
                          @handleChange="setNotificationMessageType($event)"
                          :options="messageTypeOptions"
                      />

                    </template>
                  </b-container>
                  <hr>
                  <span class="mt-3"><strong>{{ $t('configuration.whatsapp_configuration')
                    }}</strong></span>
                  <span class="text-muted font-weight-light"> - {{ $t('configuration.whatsapp_desc')
                    }}</span>
                  <hr>

                  <b-container fluid>
                    <ConfigurationCheckbox :label="$t('configuration.notification_status')"
                                           :value="whatsappActive" @handleChange="setWhatsappActive($event)" />

                    <template v-if="whatsappActive === 'true' || whatsappActive === true">
                      <br>
                      <SendForSelection title="Send Notification For"
                                        :label="$t('configuration.send_for')" :value="whatsappSendFor"
                                        :radioButtonOptions="sendForOptions"
                                        @handleRadioButtonChange="handleWhatsappSendFor($event)"
                                        :integration_value="whatsappSelectedIntegrations"
                                        @handleIntegrationChange="setWhatsappSelectedIntegrations($event)"
                                        :account_value="whatsappSelectedAccounts"
                                        @handleAccountChange="setWhatsappSelectedAccounts($event)" />
                      <br>

                      <TimeSelection :time_from="whatsapp_time_from"
                                     @handleTimeFrom="handleWhatsappTimeFrom($event)" :time_to="whatsapp_time_to"
                                     @handleTimeTo="handleWhatsappTimeTo($event)" />

                      <br>
                      <ConfigurationCheckboxGroup
                          :value="whatsappMessageType"
                          @handleChange="setWhatsappMessageType($event)"
                          :options="messageTypeOptions"
                      />
                    </template>
                  </b-container>
                  <hr>
                  <span class="mt-3"><strong>{{ $t('configuration.email_configuration') }}</strong></span>
                  <span class="text-muted font-weight-light"> - SMTP</span>
                  <hr>

                  <b-container fluid>
                    <ConfigurationCheckbox :label="$t('configuration.email_configuration_smtp')"
                                           title="Email Configuration(SMTP)" :value="emailActive"
                                           @handleChange="setEmailActive($event)" />

                    <template v-if="emailActive === 'true' || emailActive === true">
                      <br>
                      <b-row>
                        <b-col sm="12" md="3" lg="2" class="mb-2" v-b-tooltip.hover title="Email">{{
                            $t('simple.email') }} :</b-col>
                        <b-col sm="12" md="5">
                          <div>
                            <b-form-input v-model="email_address"></b-form-input>
                          </div>

                        </b-col>
                      </b-row>
                      <br>
                      <b-row>
                        <b-col sm="12" md="3" lg="2" class="mb-2" v-b-tooltip.hover
                               title="Email host">{{
                            $t('configuration.email_host')
                          }}</b-col>
                        <b-col sm="12" md="5">
                          <div>
                            <b-form-input v-model="email_host"></b-form-input>
                          </div>

                        </b-col>
                      </b-row>
                      <br>
                      <b-row>
                        <b-col sm="12" md="3" lg="2" class="mb-2" v-b-tooltip.hover
                               title="email_username">{{
                            $t('configuration.email_username') }}</b-col>
                        <b-col sm="12" md="5">
                          <div>
                            <b-form-input v-model="email_username"></b-form-input>
                          </div>

                        </b-col>
                      </b-row>
                      <br>
                      <PasswordInput :label="$t('configuration.email_password')" :value="emailPassword"
                                     @handlePasswordChange="setEmailPassword($event)" />
                      <br>
                      <b-row>
                        <b-col sm="12" md="3" lg="2" class="mb-2" v-b-tooltip.hover
                               title="Email port">{{
                            $t('configuration.email_port')
                          }}</b-col>
                        <b-col sm="12" md="5">
                          <div>
                            <b-form-input v-model="email_port"></b-form-input>
                          </div>
                        </b-col>
                      </b-row>
                      <br>
                      <b-row>
                        <b-col sm="12" md="3" lg="2" class="mb-2"></b-col>
                        <b-col sm="12" md="5">
                          <b-btn class="d-flex align-items-center flex-nowrap"
                                 @click="handleTestEmail"
                                 :variant="emailVerified === 'sent' ? 'success' : 'danger'">
                            <div class="text-nowrap">{{ $t('simple.send_test_email') }} - </div>
                            <v-wait for="test_email" class="ml-1 d-flex align-items-center">
                              <b-spinner variant="light" small slot="waiting"></b-spinner>
                              <template v-if="emailVerified === 'sent'">
                                <span> {{ $t('simple.email_verified') }}</span>
                              </template>
                              <template v-else>
                                <span> {{ $t('simple.email_not_verified') }}</span>
                              </template>
                            </v-wait>
                          </b-btn>
                        </b-col>
                      </b-row>
                      <br>
                      <SendForSelection title="Send Email For" :label="$t('configuration.send_for')"
                                        :value="emailSendFor" :radioButtonOptions="sendForOptions"
                                        @handleRadioButtonChange="handleEmailSendFor($event)"
                                        :integration_value="emailSelectedIntegrations"
                                        @handleIntegrationChange="setEmailSelectedIntegrations($event)"
                                        :account_value="emailSelectedAccounts"
                                        @handleAccountChange="setEmailSelectedAccounts($event)" />
                      <br>

                      <TimeSelection :time_from="email_time_from"
                                     @handleTimeFrom="handleEmailTimeFrom($event)" :time_to="email_time_to"
                                     @handleTimeTo="handleEmailTimeTo($event)" />

                      <br>
                      <ConfigurationCheckboxGroup
                          :value="emailMessageType"
                          @handleChange="setEmailMessageType($event)"
                          :options="messageTypeOptions"
                      />

                    </template>
                  </b-container>

                  <hr>
                  <span><strong>{{ $t('configuration.ticket_notify') }}</strong></span>
                  <span class="text-muted font-weight-light"> - {{ $t('configuration.ticket_notify_desc')
                    }}</span>
                  <hr>

                  <b-container fluid>
                    <ConfigurationCheckbox :label="$t('configuration.ticket_notify_status')"
                                           :value="ticketReminderActive" @handleChange="setTicketReminderActive($event)" />

                    <template v-if="ticketReminderActive === 'true' || ticketReminderActive === true">
                      <br>
                      <b-row>
                        <b-col sm="12" md="3" lg="2" class="mb-2" v-b-tooltip.hover>{{
                            $t('ticket.ticket') }} {{ $t('ticket.status') }}</b-col>
                        <b-col sm="12" md="5">
                          <treeselect v-model="ticket_status" :multiple="true"
                                      :placeholder="$t('ticket.status_select')" :options="ticket_statuses"
                                      :normalizer="normalizerTicketReminder">
                          </treeselect>
                        </b-col>
                      </b-row>
                      <br>
                      <b-row class="align-items-center">
                        <b-col sm="12" md="3" lg="2" class="mb-2" v-b-tooltip.hover>
                          {{ $t('configuration.ticket_notify_cycle') }}
                          <b-button v-if="ticket_reminder_cycle.length > 0" size="sm"
                                    class="bg-light rounded-circle border-success"
                                    @click="addTicketReminder"><font-awesome-icon :icon="'plus'"
                                                                                  class="text-success" /> </b-button>
                        </b-col>
                        <b-col sm="12" md="5">
                          <template v-if="ticket_reminder_cycle.length === 0">
                            <b-button size="sm"
                                      class="bg-light rounded-pill border-success text-success"
                                      @click="addTicketReminder"><font-awesome-icon :icon="'plus'"
                                                                                    class="" /> {{ $t('default.add') }} </b-button>
                          </template>
                          <template v-else>
                            <b-card class="flex-column flex-xl-row p-1" no-body
                                    v-for="(reminder, reminder_index) in ticket_reminder_cycle"
                                    :key="ticket_reminder_cycle.day">
                              <b-input-group :append="$t('configuration.ticket_notify_cycle_day')"
                                             class="mr-1">
                                <b-form-input type="number" min="1" max="365"
                                              v-model="reminder.day"></b-form-input>
                              </b-input-group>
                              <b-input-group
                                  :append="$t('configuration.ticket_notify_cycle_hour')"
                                  class="mt-1 mt-xl-0 mr-1">
                                <b-form-input type="time" min="00:00" max="23:00" step="3600"
                                              v-model="reminder.hour"></b-form-input>
                              </b-input-group>
                              <b-button size="sm"
                                        class="bg-light rounded-lg border-danger text-danger mt-1 mt-xl-0"
                                        @click="removeTicketReminder(reminder_index)">
                                <font-awesome-icon :icon="'times'" />
                              </b-button>
                            </b-card>
                          </template>
                        </b-col>
                      </b-row>
                    </template>
                  </b-container>

                  <hr>
                  <span><strong>{{ $t('configuration.report_notify') }}</strong></span>
                  <span class="text-muted font-weight-light"> - {{ $t('configuration.report_notify_desc')
                    }}</span>
                  <hr>

                  <b-container fluid>
                    <ConfigurationCheckbox :label="$t('default.status')"
                                           :value="reportNotifyActive" @handleChange="setReportNotifyActive($event)" />

                    <template v-if="reportNotifyActive === 'true' || reportNotifyActive === true">
                      <br>
                      <b-row>
                        <b-col sm="12" md="3" lg="2" class="mb-2" v-b-tooltip.hover>{{
                            $t('reports.reports') }}</b-col>
                        <b-col sm="12" md="5">
                          <treeselect v-model="report_notify_type" :multiple="true"
                                      :placeholder="$t('reports.reports')" :options="reportNotifyTypeOptions"
                                      :normalizer="normalizerReportNotify">
                          </treeselect>
                        </b-col>
                      </b-row>
                      <br>
                      <b-row>
                        <b-col sm="12" md="3" lg="2" class="mb-2" v-b-tooltip.hover>{{ $t('configuration.time_range') }}</b-col>
                        <b-col sm="12" md="5">
                          <treeselect v-model="report_notify_interval" :multiple="true"
                                      :placeholder="$t('default.select')" :options="reportNotifyIntervalOptions"
                                      :normalizer="normalizerReportNotify">
                          </treeselect>
                        </b-col>
                      </b-row>

                    </template>
                  </b-container>

                </div>
              </v-wait>

            </v-wait>
            <hr>
            <!-- Page footer -->


            <div class="py-3 px-3">
              <div v-b-tooltip.hover.right="{
                   title:!user_permissions.includes('update-configurations')? $t('permission.permission_denied', { permission: 'update-configurations' }) : '',customClass: 'tooltip-dark' }"
                    style="display: inline-block">
                <b-button variant="success"
                          :class="['px-3',{ 'cursor-not-allowed': !user_permissions.includes('update-configurations') }]"
                          :disabled="!user_permissions.includes('update-configurations')"
                          @click="updateConfigurations">{{
                    $t('default.save')
                  }}
                </b-button>
              </div>
            </div>


          </div>
          <div class="alert alert-danger text-center" style="max-width: 50%; margin: 0 auto;" v-if="is_active === 0 && permissionsReady && !user_permissions.includes('read-configurations')">
            {{ $t('permission.permission_denied',{ permission: 'read-configurations'}) }}
          </div>
          <div v-if="is_active === 1 && user_permissions.includes('read-automations')" class=" tab-1 w-100 bg-white rounded py-2 shadow-widget border">

            <!-- Page header -->
            <div class="px-3">

              <div class="d-flex">

                <h4>{{$t('simple.automation')}}</h4>

                <div class="ml-auto align-self-center">


                </div>

              </div>

              <span class="text-muted font-weight-light">{{ $t('page.automations_desc') }}</span>

            </div>

            <hr>
            <v-wait  for="automations">
              <loading slot="waiting" />
                <!-- Page content -->
                <div class="px-3" >
                  <span><strong>{{ $t('configuration.greeting_messages') }}</strong></span>
                  <span class="text-muted font-weight-light"> - {{ $t('configuration.greeting_desc') }}</span>
                  <hr>
                  <b-container fluid>
                    <b-row>
                    <b-col :md="4">
                      <treeselect  :value="account_value"  @input="(value) => handleSelectedAccounts(value)"
                                   :options="account_options" :multiple="true" value-format="object"
                                   :placeholder="$t('configuration.select_accounts')" :normalizer="accountNormalizer">
                        <label slot="option-label" slot-scope="{ node }">
                          <font-awesome-icon :style="{ color: node.raw.color }"
                                             :icon="['fab', node.raw.integration.icon]" />
                          {{ node.raw.name }}
                        </label>
                        <div slot="value-label" slot-scope="{ node }">
                          <font-awesome-icon :style="{ color: node.raw.color }"
                                             :icon="['fab', node.raw.integration.icon]" />
                          <span>{{ node.raw.name }}</span>
                        </div>
                      </treeselect>
                    </b-col>
                    </b-row>
                    <!-- Display selected accounts dynamically using rows and columns -->
                    <b-row v-if="account_value.length > 0" class="mt-4 d-md-flex d-none" align-v="center" >
                      <b-col md="2" sm="6">
                        <strong>{{ $t('simple.automation_integration')}}</strong>
                      </b-col>
                      <b-col md="2" sm="6">
                        <strong>{{ $t('simple.automation_account')}}</strong>
                      </b-col>
                      <b-col md="2" sm="6">
                        <strong>{{ $t('simple.automation_greeting_status')}}</strong>
                      </b-col>
                      <b-col md="2" sm="6">
                        <strong>{{ $t('simple.automation_message_content')}}</strong>
                      </b-col>

                      <b-col md="2" sm="6">
                        <strong>{{ $t('simple.automation_actions')}}</strong>
                      </b-col>
                    </b-row>
                    <hr v-if="account_value.length > 0"/>
                    <b-row class="mt-4" v-for="(account, index) in account_value" :key="index" align-v="center">
                      <b-col md="2" sm="6" class="d-flex justify-content-between my-2">
                        <strong class="d-inline-flex d-md-none">{{ $t('simple.automation_integration')}}</strong>
                       {{ account.integration_id }}
                      </b-col>
                      <b-col md="2" sm="6" class="d-flex justify-content-between my-2">
                        <strong class="d-inline-flex d-md-none">{{ $t('simple.automation_account')}}</strong>
                      {{ account.name }}
                      </b-col>
                      <b-col md="2" sm="6" class="d-flex justify-content-between my-2">
                        <strong class="d-inline-flex d-md-none">{{ $t('simple.automation_greeting_status')}}</strong>
                        <ConfigurationCheckbox
                            :label="''"
                            :value="account.automation.greeting_status"
                            @handleChange="setGreetingStatus(account, $event)" />
                      </b-col>
                      <b-col md="2" sm="6" class="d-flex justify-content-between my-2">
                        <strong class="d-inline-flex d-md-none">{{ $t('simple.automation_message_content')}}</strong>
                        {{ account.automation.message_content ? account.automation.message_content.slice(0, 50) + (account.automation.message_content.length > 50 ? '...' : '') :  $t('simple.automation_not_set_message') }}
                      </b-col>
                      <b-col md="2" sm="6" class="d-flex justify-content-between my-2">
                        <strong class="d-inline-flex d-md-none">{{ $t('simple.automation_actions')}}</strong>
                        <b-dropdown right :text="$t('simple.actions')" size="sm">
                          <b-dropdown-item  @click="editMessageData(account)">{{$t('simple.automation_manage_message')}}</b-dropdown-item>
                          <b-dropdown-item v-if="user_permissions.includes('delete-automations')" @click="deleteAutomation(account.id)">{{$t('simple.delete') }}</b-dropdown-item>
                        </b-dropdown>
                      </b-col>
                    </b-row>
                    <GreetingMessage
                        v-if="selectedAccount"
                        :account="selectedAccount"
                        @save="handleMessageSave"
                        @close="selectedAccount = null"
                    />
                  </b-container>
                </div>
            </v-wait>
            <hr>
            <!-- Page footer -->


            <div class="py-3 px-3">
              <div v-b-tooltip.hover.right="{
                   title: !user_permissions.includes('update-automations')? $t('permission.permission_denied', { permission: 'update-automations' }) : '',customClass: 'tooltip-dark' }"
                    style="display: inline-block">
                <b-button variant="success"
                          :class="['px-3',{ 'cursor-not-allowed': !user_permissions.includes('update-automations') }]"
                          :disabled="!user_permissions.includes('update-automations')"
                          @click="handleUpdateAutomations">{{
                    $t('default.save')
                  }}
                </b-button>
              </div>
            </div>

            <hr>

            <!-- Forward to CRM Section -->
            <v-wait for="crm_forward_automations">
              <loading slot="waiting" />
              <div class="mb-3">
                <div class="px-3">
                  <span><strong>{{ $t('configuration.forward_crm_title') }}</strong></span>
                  <span class="text-muted font-weight-light"> - {{ $t('configuration.forward_crm_desc') }}</span>
                </div>
                <hr class="mb-0">

                <div class="position-relative">

                  <!-- Overlay: CRM not configured (locked) -->
                  <div v-if="!crmIsAvailable" class="crm-state-overlay">
                    <div class="crm-overlay-badge crm-overlay-locked">
                      <font-awesome-icon :icon="'lock'" class="text-danger mr-2 flex-shrink-0" />
                      <span>{{ $t('simple.forward_crm_locked_tooltip') }}</span>
                    </div>
                  </div>

                  <!-- Overlay: CRM active but has error (paused) -->
                  <div v-else-if="crmError" class="crm-state-overlay">
                    <div class="crm-overlay-badge crm-overlay-paused">
                      <font-awesome-icon :icon="'exclamation-circle'" class="text-warning mr-2 flex-shrink-0" />
                      <span>
                        <strong>{{ $t('simple.forward_crm_paused_message') }}</strong>
                        {{ $t('simple.forward_crm_paused_go_to_settings') }}
                      </span>
                    </div>
                  </div>

                  <!-- Section content — always visible through overlay -->
                  <div class="px-3 pt-3">
                    <b-container fluid>
                      <b-row>
                        <b-col :md="4">
                          <treeselect
                            :value="crm_forward_account_value"
                            @input="(value) => handleSelectedCrmForwardAccounts(value)"
                            :options="account_options"
                            :multiple="true"
                            value-format="object"
                            :placeholder="$t('configuration.select_accounts')"
                            :normalizer="accountNormalizer"
                          >
                            <label slot="option-label" slot-scope="{ node }">
                              <font-awesome-icon :style="{ color: node.raw.color }" :icon="['fab', node.raw.integration.icon]" />
                              {{ node.raw.name }}
                            </label>
                            <div slot="value-label" slot-scope="{ node }">
                              <font-awesome-icon :style="{ color: node.raw.color }" :icon="['fab', node.raw.integration.icon]" />
                              <span>{{ node.raw.name }}</span>
                            </div>
                          </treeselect>
                        </b-col>
                      </b-row>

                      <b-row v-if="crm_forward_account_value.length > 0" class="mt-4 d-md-flex d-none" align-v="center">
                        <b-col md="2" sm="6"><strong>{{ $t('simple.automation_integration') }}</strong></b-col>
                        <b-col md="2" sm="6"><strong>{{ $t('simple.automation_account') }}</strong></b-col>
                        <b-col md="2" sm="6"><strong>{{ $t('simple.automation_forward_status') }}</strong></b-col>
                        <b-col md="2" sm="6"><strong>{{ $t('simple.automation_forward_conditions') }}</strong></b-col>
                        <b-col md="2" sm="6"><strong>{{ $t('simple.automation_actions') }}</strong></b-col>
                      </b-row>
                      <hr v-if="crm_forward_account_value.length > 0" />

                      <b-row
                        class="mt-4"
                        v-for="(account, index) in crm_forward_account_value"
                        :key="'crm-' + index"
                        align-v="center"
                      >
                        <b-col md="2" sm="6" class="d-flex justify-content-between my-2">
                          <strong class="d-inline-flex d-md-none">{{ $t('simple.automation_integration') }}</strong>
                          {{ account.integration_id }}
                        </b-col>
                        <b-col md="2" sm="6" class="d-flex justify-content-between my-2">
                          <strong class="d-inline-flex d-md-none">{{ $t('simple.automation_account') }}</strong>
                          {{ account.name }}
                        </b-col>
                        <b-col md="2" sm="6" class="d-flex justify-content-between my-2">
                          <strong class="d-inline-flex d-md-none">{{ $t('simple.automation_forward_status') }}</strong>
                          <ConfigurationCheckbox
                            :label="''"
                            :value="account.automation.forward_crm_status"
                            @handleChange="setCrmForwardStatus(account, $event)" />
                        </b-col>
                        <b-col md="2" sm="6" class="d-flex justify-content-between my-2">
                          <strong class="d-inline-flex d-md-none">{{ $t('simple.automation_forward_conditions') }}</strong>
                          <span>
                            <span v-if="account.automation.forward_incoming_crm" class="d-block small">&#8594; {{ $t('simple.forward_incoming_label') }}</span>
                            <span v-if="account.automation.forward_outgoing_crm" class="d-block small">&#8592; {{ $t('simple.forward_outgoing_label') }}</span>
                            <span v-if="!account.automation.forward_incoming_crm && !account.automation.forward_outgoing_crm" class="text-muted small">{{ $t('simple.automation_not_set_message') }}</span>
                          </span>
                        </b-col>
                        <b-col md="2" sm="6" class="d-flex justify-content-between my-2">
                          <strong class="d-inline-flex d-md-none">{{ $t('simple.automation_actions') }}</strong>
                          <b-dropdown right :text="$t('simple.actions')" size="sm">
                            <b-dropdown-item @click="editCrmForwardConditions(account)">{{ $t('simple.automation_manage_conditions') }}</b-dropdown-item>
                            <b-dropdown-item v-if="user_permissions.includes('delete-automations')" @click="deleteAutomation(account.id)">{{ $t('simple.delete') }}</b-dropdown-item>
                          </b-dropdown>
                        </b-col>
                      </b-row>

                      <ForwardCrmConditions
                        v-if="selectedCrmForwardAccount"
                        :account="selectedCrmForwardAccount"
                        @save="handleCrmForwardConditionsSave"
                        @close="selectedCrmForwardAccount = null"
                      />
                    </b-container>
                  </div>

                  <hr>
                  <div class="py-3 px-3">
                    <div v-b-tooltip.hover.right="{
                         title: !user_permissions.includes('update-automations') ? $t('permission.permission_denied', { permission: 'update-automations' }) : '', customClass: 'tooltip-dark' }"
                         style="display: inline-block">
                      <b-button
                        variant="success"
                        :class="['px-3', { 'cursor-not-allowed': !user_permissions.includes('update-automations') }]"
                        :disabled="!user_permissions.includes('update-automations')"
                        @click="handleUpdateCrmForwardAutomations"
                      >{{ $t('default.save') }}</b-button>
                    </div>
                  </div>

                </div>
              </div>
            </v-wait>


          </div>
          <div class="alert alert-danger text-center" style="max-width: 50%; margin: 0 auto;" v-if="is_active === 1 && permissionsReady && !user_permissions.includes('read-automations')">
            {{ $t('permission.permission_denied',{ permission: 'read-automations'}) }}
          </div>
        </b-col>
      </b-row>
</template>


<script>


import { mapActions, mapGetters, mapMutations } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import { getTicketStatuses } from '../../utils/ticket.js';
import ConfigurationCheckbox from './Configurations/Checkbox.vue'
import PasswordInput from './Configurations/PasswordInput.vue'
import SendForSelection from "./Configurations/SendForSelection.vue";
import TimeSelection from "./Configurations/TimeSelection.vue";
import ConfigurationCheckboxGroup from "./Configurations/CheckboxGroup.vue";
import GreetingMessage from "../Modal/GreetingMessage.vue";
import ForwardCrmConditions from "../Modal/ForwardCrmConditions.vue";

export default {

    components: {
        Treeselect,
        ConfigurationCheckbox,
        GreetingMessage,
        ForwardCrmConditions,
        PasswordInput,
        SendForSelection,
        TimeSelection,
        ConfigurationCheckboxGroup
    },

    async mounted() {
        // Component mounted
        console.log('Configurations component mounted.')
        await this.fetchConfigurations();
    },

    destroyed() {
        // Component destroyed
        console.log('Configurations component destroyed.');
    },

    data: function () {
        return {
            ticket_statuses: getTicketStatuses,
            is_active: 0,
            account_value: [],
            selectedAccount: null,
            crm_forward_account_value: [],
            selectedCrmForwardAccount: null,
        }
    },

    metaInfo: function () {

        return {
            title: this.$t('page.configurations'),
        }

    },

    methods: {

        // Map actions
        ...mapActions('Configurations', [
            'fetchConfigurations',
            'fetchAutomationsAccounts',
            'updateConfigurations',
            'updateAutomations',
            'updateCrmForwardAutomations',
            'removeAutomations',
            'verifyEmailAddress',
            'appendTicketReminderCycle',
        ]),
        ...mapActions('Accounts', [
            'fetchAccounts',
        ]),
        ...mapActions('Integrations', [
            'fetchCrmIntegration',
        ]),
        // Map Mutations
        ...mapMutations('Configurations', [
            'setPlayerMode',
            'setGamificationCounter',
            'setGamificationLastReplyCounter',
            'setWarnMessageCount',
            'setWarnPopularAccountCount',
            'setEmail',
            'setEmailActive',
            'setEmailHost',
            'setEmailUsername',
            'setEmailPassword',
            'setEmailPort',
            'setEmailSendFor',
            'setEmailSelectedIntegrations',
            'setEmailSelectedAccounts',
            'setEmailMessageType',
            'setEmailTimeFrom',
            'setEmailTimeTo',
            'setNotificationActive',
            'setNotificationSendFor',
            'setNotificationSelectedIntegrations',
            'setNotificationSelectedAccounts',
            'setNotificationMessageType',
            'setNotificationTimeFrom',
            'setNotificationTimeTo',
            'setWhatsappActive',
            'setWhatsappSendFor',
            'setWhatsappSelectedIntegrations',
            'setWhatsappSelectedAccounts',
            'setWhatsappMessageType',
            'setWhatsappTimeFrom',
            'setWhatsappTimeTo',
            'setTranslationActive',
            'setTranslationApiKey',
            'setEmailVerified',
            'setTicketReminderActive',
            'setTicketReminderTicketStatus',
            'setTicketReminderCycle',
            'setReportNotifyActive',
            'setReportNotifyType',
            'setReportNotifyInterval',
        ]),
      activeTab: async function (value) {
        if (value === 1) {
            await Promise.all([
                this.fetchAutomationsAccounts(),
                this.fetchCrmIntegration(),
            ]);
            this.account_value = this.account_options.filter(acc => acc.automation !== null);
            this.crm_forward_account_value = this.account_options.filter(
                acc => acc.automation !== null && (acc.automation.forward_incoming_crm || acc.automation.forward_outgoing_crm)
            );
        }
        this.is_active = value;
      },

        normalizerTicketReminder: function (node) {
            return {
                id: node.id,
                label: this.$t('ticket.' + node.name)
            }
        },

        normalizerReportNotify: function (node) {
            return {
                id: node.value,
                label: this.$t('reports.' + node.text)
            }
        },

      accountNormalizer(node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children,
        }
      },

      addTicketReminder() {
            const reminder = {
                day: '1',
                hour: '15:00'
            }
            this.appendTicketReminderCycle(reminder)
        },

        removeTicketReminder(index) {
            const reminders = [...this.ticket_reminder_cycle]
            reminders.splice(index, 1);
            this.setTicketReminderCycle(reminders)
        },

        async handleTestEmail() {
            const email_data = {
                email_host: this.email_host,
                email_username: this.email_username,
                email_password: this.email_password,
                email_port: this.email_port
            }

            await this.verifyEmailAddress(email_data)

        },

        handleNotificationSendFor(value) {
            if (value == 'all') {
                this.setNotificationSelectedIntegrations([])
                this.setNotificationSelectedAccounts([])
            } else if (value == 'integration') {
                this.setNotificationSelectedAccounts([])
            } else if (value == 'account') {
                this.setNotificationSelectedIntegrations([])
            }
            this.setNotificationSendFor(value);
        },
      buildAutomationObject(account) {
        return {
            greeting_status:      account.automation?.greeting_status ?? false,
            message_content:      account.automation?.message_content ?? null,
            file:                 account.automation?.file ?? null,
            forward_crm_status:   account.automation?.forward_crm_status ?? false,
            forward_incoming_crm: account.automation?.forward_incoming_crm ?? false,
            forward_outgoing_crm: account.automation?.forward_outgoing_crm ?? false,
        };
      },

      handleSelectedAccounts(value) {
        this.account_value = value.map(account => ({
            ...account,
            automation: this.buildAutomationObject(account),
        }));
      },

      handleSelectedCrmForwardAccounts(value) {
        this.crm_forward_account_value = value.map(account => ({
            ...account,
            automation: this.buildAutomationObject(account),
        }));
      },

      editMessageData(account) {
        this.selectedAccount = account;
      },

      editCrmForwardConditions(account) {
        this.selectedCrmForwardAccount = account;
      },

      setCrmForwardStatus(account, status) {
        this.crm_forward_account_value = this.crm_forward_account_value.map(acc => {
          if (acc.id === account.id) {
            return { ...acc, automation: { ...acc.automation, forward_crm_status: status } };
          }
          return acc;
        });
      },

      setGreetingStatus(account, status) {
        this.account_value = this.account_value.map(acc => {
          if (acc.id === account.id) {
            return { ...acc, automation: { ...acc.automation, greeting_status: status } };
          }
          return acc;
        });
      },
      handleMessageSave({ accountId, content, remove_attachment = false, attachment = null }) {
        const account = this.account_value.find(acc => acc.id === accountId);
        if (account) {
          account.automation.message_content = content;
          account.automation.file = attachment;
          account.automation.remove_attachment = remove_attachment;
        }
        this.selectedAccount = null;
      },

      handleCrmForwardConditionsSave({ accountId, forwardIncoming, forwardOutgoing }) {
        this.crm_forward_account_value = this.crm_forward_account_value.map(acc => {
          if (acc.id === accountId) {
            return {
              ...acc,
              automation: {
                ...acc.automation,
                forward_incoming_crm: forwardIncoming,
                forward_outgoing_crm: forwardOutgoing,
              },
            };
          }
          return acc;
        });
        this.selectedCrmForwardAccount = null;
      },

      buildAutomationPayload(accounts) {
        return accounts
            .filter(account => account.automation)
            .map(account => {
                let { file, remove_attachment = false } = account.automation;
                if (!(file instanceof File)) {
                    file = null;
                    remove_attachment = remove_attachment ?? false;
                }
                return {
                    account_id:      account.id,
                    greeting_status: account.automation.greeting_status ?? false,
                    message_content: account.automation.message_content ?? '',
                    file,
                    remove_attachment,
                };
            });
      },

      async handleUpdateAutomations() {
        try {
            const automationData = this.buildAutomationPayload(this.account_value);
            await this.updateAutomations(automationData);
            this.account_value = this.account_value.map(account => {
                const matchedAccount = this.account_options.find(option => option.id === account.id);
                return matchedAccount ? matchedAccount : account;
            });
        } catch (error) {
            console.error('Error updating automations:', error);
        }
      },

      async handleUpdateCrmForwardAutomations() {
        try {
            const automationData = this.crm_forward_account_value
                .filter(account => account.automation)
                .map(account => ({
                    account_id:           account.id,
                    forward_crm_status:   account.automation.forward_crm_status ?? false,
                    forward_incoming_crm: account.automation.forward_incoming_crm ?? false,
                    forward_outgoing_crm: account.automation.forward_outgoing_crm ?? false,
                }));
            await this.updateCrmForwardAutomations(automationData);
            this.crm_forward_account_value = this.crm_forward_account_value.map(account => {
                const matchedAccount = this.account_options.find(option => option.id === account.id);
                return matchedAccount ? matchedAccount : account;
            });
        } catch (error) {
            console.error('Error updating CRM forward automations:', error);
        }
      },
      async deleteAutomation(accountId) {
        // Remove from greeting section
        const greetingIndex = this.account_value.findIndex(acc => acc.id === accountId);
        if (greetingIndex !== -1) {
            const account = this.account_value[greetingIndex];
            if (account.automation && account.automation.id) {
                await this.removeAutomations(account.automation.id);
            }
            this.account_value.splice(greetingIndex, 1);
        }

        // Remove from CRM forward section (the automation record is shared)
        const crmIndex = this.crm_forward_account_value.findIndex(acc => acc.id === accountId);
        if (crmIndex !== -1 && greetingIndex === -1) {
            const account = this.crm_forward_account_value[crmIndex];
            if (account.automation && account.automation.id) {
                await this.removeAutomations(account.automation.id);
            }
        }
        if (crmIndex !== -1) {
            this.crm_forward_account_value.splice(crmIndex, 1);
        }
      },
        handleWhatsappSendFor(value) {
            if (value == 'all') {
                this.setWhatsappSelectedIntegrations([])
                this.setWhatsappSelectedAccounts([])
            } else if (value == 'integration') {
                this.setWhatsappSelectedAccounts([])
            } else if (value == 'account') {
                this.setWhatsappSelectedIntegrations([])
            }
            this.setWhatsappSendFor(value);
        },

        handleEmailSendFor(value) {
            if (value == 'all') {
                this.setEmailSelectedIntegrations([])
                this.setEmailSelectedAccounts([])
            } else if (value == 'integration') {
                this.setEmailSelectedAccounts([])
            } else if (value == 'account') {
                this.setEmailSelectedIntegrations([])
            }
            this.setEmailSendFor(value);
        },

        handleNotificationTimeFrom(value) {
            this.setNotificationTimeFrom(this.$moment(this.$moment.utc(value)).format('HH:mm:ss'));
        },

        handleNotificationTimeTo(value) {
            this.setNotificationTimeTo(this.$moment(this.$moment.utc(value)).format('HH:mm:ss'));
        },

        handleWhatsappTimeFrom(value) {
            this.setWhatsappTimeFrom(this.$moment(this.$moment.utc(value)).format('HH:mm:ss'));
        },

        handleWhatsappTimeTo(value) {
            this.setWhatsappTimeTo(this.$moment(this.$moment.utc(value)).format('HH:mm:ss'));
        },

        handleEmailTimeFrom(value) {
            this.setEmailTimeFrom(this.$moment(this.$moment.utc(value)).format('HH:mm:ss'));
        },

        handleEmailTimeTo(value) {
            this.setEmailTimeTo(this.$moment(this.$moment.utc(value)).format('HH:mm:ss'));
        },
    },

    computed: {

        // Map getters
        ...mapGetters({

            user: 'User/getUser',

            // Player Mode
            playerMode: 'Configurations/getPlayerMode',

            // Gamification Count
            gamificationCounter: 'Configurations/getGamificationCounter',

            // Gamification Last Reply Count
            gamificationLastReplyCounter: 'Configurations/getGamificationLastReplyCounter',

            // Warn Message Count
            warnMessageCount: 'Configurations/getWarnMessageCount',

            // Warn Popular Account Count
            warnPopularAccountCount: 'Configurations/getWarnPopularAccountCount',


            emailAddress: 'Configurations/getEmail',
            emailActive: 'Configurations/getEmailActive',
            emailHost: 'Configurations/getEmailHost',
            emailUsername: 'Configurations/getEmailUsername',
            emailPassword: 'Configurations/getEmailPassword',
            emailPort: 'Configurations/getEmailPort',
            emailSendFor: 'Configurations/getEmailSendFor',
            emailSelectedIntegrations: 'Configurations/getEmailSelectedIntegrations',
            emailSelectedAccounts: 'Configurations/getEmailSelectedAccounts',
            emailMessageType: 'Configurations/getEmailMessageType',
            emailTimeFrom: 'Configurations/getEmailTimeFrom',
            emailTimeTo: 'Configurations/getEmailTimeTo',

            emailVerified: 'Configurations/getEmailVerified',

            notificationActive: 'Configurations/getNotificationActive',
            notificationSendFor: 'Configurations/getNotificationSendFor',
            notificationSelectedIntegrations: 'Configurations/getNotificationSelectedIntegrations',
            notificationSelectedAccounts: 'Configurations/getNotificationSelectedAccounts',
            notificationMessageType: 'Configurations/getNotificationMessageType',
            notificationTimeFrom: 'Configurations/getNotificationTimeFrom',
            notificationTimeTo: 'Configurations/getNotificationTimeTo',

            whatsappActive: 'Configurations/getWhatsappActive',
            whatsappSendFor: 'Configurations/getWhatsappSendFor',
            whatsappSelectedIntegrations: 'Configurations/getWhatsappSelectedIntegrations',
            whatsappSelectedAccounts: 'Configurations/getWhatsappSelectedAccounts',
            whatsappMessageType: 'Configurations/getWhatsappMessageType',
            whatsappTimeFrom: 'Configurations/getWhatsappTimeFrom',
            whatsappTimeTo: 'Configurations/getWhatsappTimeTo',



            sendForOptions: 'Configurations/getSendForOptions',
            messageTypeOptions: 'Configurations/getMessageTypeOptions',


            translationActive: 'Configurations/getTranslationActive',
            translationApiKey: 'Configurations/getTranslationApiKey',


            ticketReminderActive: 'Configurations/getTicketReminderActive',
            ticketReminderTicketStatus: 'Configurations/getTicketReminderTicketStatus',
            ticketReminderCycle: 'Configurations/getTicketReminderCycle',

            reportNotifyActive: 'Configurations/getReportNotifyActive',
            reportNotifyType: 'Configurations/getReportNotifyType',
            reportNotifyTypeOptions: 'Configurations/getReportNotifyTypeOptions',
            reportNotifyInterval: 'Configurations/getReportNotifyInterval',
            reportNotifyIntervalOptions: 'Configurations/getReportNotifyIntervalOptions',
            account_options:  'Configurations/getAutomationsAccounts',
            user_permissions: 'User/getUserPermissions',
            intActive:        'Integrations/getIntActive',
            crmError:         'Integrations/getCrmError',
        }),

        crmIsAvailable() {
            return this.intActive === true || this.intActive === 'true';
        },

        report_notify_type: {

            // getter
            get: function () {
                return this.reportNotifyType;
            },

            // setter
            set: function (value) {
                // Check if we have value?
                if (value) {
                    this.setReportNotifyType(value);
                }
            },

        },
        report_notify_interval: {

            // getter
            get: function () {
                return this.reportNotifyInterval;
            },

            // setter
            set: function (value) {
                // Check if we have value?
                if (value) {
                    this.setReportNotifyInterval(value);
                }
            },

        },




        ticket_status: {

            // getter
            get: function () {
                return this.ticketReminderTicketStatus;
            },

            // setter
            set: function (value) {
                // Check if we have value?
                if (value) {
                    this.setTicketReminderTicketStatus(value);
                }
            },

        },

        ticket_reminder_cycle: {

            // getter
            get: function () {
                return this.ticketReminderCycle;
            },

            // setter
            set: function (value) {
                // Check if we have value?
                if (value) {
                    this.setTicketReminderCycle(value);
                }
            },

        },

        

        notification_time_from() {
            const date = new Date().toISOString().slice(0, 10)
            return this.$moment(this.$moment.utc(date + ' ' + this.notificationTimeFrom)).local().format('HH:mm:ss');
        },

        notification_time_to() {
            const date = new Date().toISOString().slice(0, 10)

            return this.$moment(this.$moment.utc(date + ' ' + this.notificationTimeTo)).local().format('HH:mm:ss');
        },

        whatsapp_time_from() {
            const date = new Date().toISOString().slice(0, 10)
            return this.$moment(this.$moment.utc(date + ' ' + this.whatsappTimeFrom)).local().format('HH:mm:ss');
        },

        whatsapp_time_to() {
            const date = new Date().toISOString().slice(0, 10)
            return this.$moment(this.$moment.utc(date + ' ' + this.whatsappTimeTo)).local().format('HH:mm:ss');
        },


        // player_mode
        player_mode: {

            // getter
            get: function () {
                // Get Player Mode
                return this.playerMode;
            },

            // setter
            set: function (value) {
                // Check if we have value?
                if (value) {
                    // Set Player Mode
                    this.setPlayerMode(value);
                }
            },

        },

        // Gamification Counter
        gamification_counter: {

            // getter
            get: function () {
                // Get Player Mode
                return this.gamificationCounter;
            },

            // setter
            set: function (value) {
                // Check if we have value?
                if (value) {
                    // Set Player Mode
                    this.setGamificationCounter(value);
                }
            },

        },

        // Gamification Last Reply Counter
        gamification_last_reply_counter: {

            // getter
            get: function () {
                // Get Player Mode
                return this.gamificationLastReplyCounter;
            },

            // setter
            set: function (value) {
                // Check if we have value?
                if (value) {
                    // Set Player Mode
                    this.setGamificationLastReplyCounter(value);
                }
            },

        },

        // warn Message Count
        warn_message_count: {

            // getter
            get: function () {
                // Get Player Mode
                return this.warnMessageCount;
            },

            // setter
            set: function (value) {
                // Check if we have value?
                if (value) {
                    // Set Player Mode
                    this.setWarnMessageCount(value);
                }
            },

        },

        // Warn Popular Count
        warn_popular_account_count: {

            // getter
            get: function () {
                // Get Player Mode
                return this.warnPopularAccountCount;
            },

            // setter
            set: function (value) {
                // Check if we have value?
                if (value) {
                    // Set Player Mode
                    this.setWarnPopularAccountCount(value);
                }
            },

        },

        email_address: {

            // getter
            get: function () {
                // Get Player Mode
                return this.emailAddress;
            },

            // setter
            set: function (value) {
                // Check if we have value?
                if (value) {
                    // Set Player Mode
                    this.setEmail(value);
                }
            },

        },


        email_host: {

            // getter
            get: function () {
                // Get Player Mode
                return this.emailHost;
            },

            // setter
            set: function (value) {
                // Check if we have value?
                if (value) {
                    // Set Player Mode
                    this.setEmailHost(value);
                }
            },

        },

        email_username: {

            // getter
            get: function () {
                // Get Player Mode
                return this.emailUsername;
            },

            // setter
            set: function (value) {
                // Check if we have value?
                if (value) {
                    // Set Player Mode
                    this.setEmailUsername(value);
                }
            },

        },
        email_port: {

            // getter
            get: function () {
                // Get Player Mode
                return this.emailPort;
            },

            // setter
            set: function (value) {
                // Check if we have value?
                if (value) {
                    // Set Player Mode
                    this.setEmailPort(value);
                }
            },

        },


        email_time_from() {
            const date = new Date().toISOString().slice(0, 10)
            return this.$moment(this.$moment.utc(date + ' ' + this.emailTimeFrom)).local().format('HH:mm:ss');
        },

        email_time_to() {
            const date = new Date().toISOString().slice(0, 10)
            return this.$moment(this.$moment.utc(date + ' ' + this.emailTimeTo)).local().format('HH:mm:ss');
        },
      permissionsReady() {
        return Array.isArray(this.user_permissions) && this.user_permissions.length > 0;
      }
    },

}
</script>